// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12c7A","question":"styles_question__3tvqy","inputVisibleButton":"styles_inputVisibleButton__3396C","note":"styles_note__Fnypn"};